"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var matchesState_1 = require("./matchesState");
exports.matchesState = matchesState_1.default;
var mapState_1 = require("./mapState");
exports.mapState = mapState_1.default;
var State_1 = require("./State");
exports.State = State_1.State;
var STATE_DELIMITER = '.';
var HISTORY_KEY = '$history';
var StateNode = /** @class */ (function () {
    function StateNode(config) {
        var _this = this;
        this.config = config;
        this.__cache = {
            events: undefined,
            relativeValue: new Map(),
            initialState: undefined
        };
        this.key = config.key || '(machine)';
        this.parent = config.parent;
        this.machine = this.parent ? this.parent.machine : this;
        this.id = this.parent
            ? this.parent.id + STATE_DELIMITER + this.key
            : this.key;
        this.relativeId =
            this.parent && this.parent.parent
                ? this.parent.relativeId + STATE_DELIMITER + this.key
                : this.key;
        this.initial = config.initial;
        this.parallel = !!config.parallel;
        this.states = (config.states
            ? utils_1.mapValues(config.states, function (stateConfig, key) {
                return new StateNode(__assign({}, stateConfig, { key: key, parent: _this }));
            })
            : {});
        this.on = config.on;
        this.strict = !!config.strict;
        this.onEntry = config.onEntry
            ? [].concat(config.onEntry)
            : undefined;
        this.onExit = config.onExit
            ? [].concat(config.onExit)
            : undefined;
    }
    StateNode.prototype.getStateNodes = function (state) {
        var _this = this;
        var stateValue = state instanceof State_1.State ? state.value : utils_1.toTrie(state);
        if (typeof stateValue === 'string') {
            var initialStateValue = this.states[stateValue].initial;
            return initialStateValue
                ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a))
                : [this.states[stateValue]];
        }
        var subStateKeys = Object.keys(stateValue);
        var subStateNodes = subStateKeys.map(function (subStateKey) { return _this.states[subStateKey]; });
        return subStateNodes.concat(subStateKeys
            .map(function (subStateKey) {
            return _this.states[subStateKey].getStateNodes(stateValue[subStateKey]);
        })
            .reduce(function (a, b) { return a.concat(b); }));
        var _a;
    };
    StateNode.prototype.handles = function (event) {
        var eventType = utils_1.getEventType(event);
        if (this.on) {
            return eventType in this.on;
        }
        return false;
    };
    StateNode.prototype.transition = function (state, event, extendedState) {
        if (this.strict) {
            var eventType = utils_1.getEventType(event);
            if (this.events.indexOf(eventType) === -1) {
                throw new Error("Machine '" + this.id + "' does not accept event '" + eventType + "'");
            }
        }
        // const stateValue = toTrie(state);
        var _a = this.transitionStateValue(state, event, extendedState), nextStateValue = _a[0], nextActions = _a[1];
        if (!nextStateValue) {
            return State_1.State.inert(state);
        }
        return new State_1.State(
        // next state value
        nextStateValue, 
        // history
        State_1.State.from(state), 
        // effects
        nextActions.onExit.concat(nextActions.actions).concat(nextActions.onEntry));
    };
    StateNode.prototype.transitionStateValue = function (state, event, extendedState) {
        var _this = this;
        var history = state instanceof State_1.State ? state.history : undefined;
        var stateValue = utils_1.toTrie(state);
        if (typeof stateValue === 'string') {
            if (!this.states[stateValue]) {
                throw new Error("State '" + stateValue + "' does not exist on machine '" + this.id + "'");
            }
            var subStateNode = this.states[stateValue];
            if (subStateNode.states && subStateNode.initial) {
                var initialStateValue = subStateNode.initialState.value;
                stateValue = (_a = {}, _a[stateValue] = initialStateValue, _a);
            }
            else {
                return subStateNode.next(event, history ? history.value : undefined, extendedState);
            }
        }
        var nextStateValue = utils_1.mapValues(stateValue, function (subStateValue, subStateKey) {
            var subHistory = history ? history.value[subStateKey] : undefined;
            var subState = new State_1.State(subStateValue, subHistory ? State_1.State.from(subHistory) : undefined);
            var subStateNode = _this.states[subStateKey];
            var nextTuple = subStateNode.transitionStateValue(subState, event, extendedState);
            return nextTuple;
        });
        if (Array.prototype.every.call(Object.keys(nextStateValue), function (key) {
            return nextStateValue[key][0] === undefined;
        })) {
            if (this.parallel) {
                return [undefined, { onEntry: [], onExit: [], actions: [] }];
            }
            var subStateKey = Object.keys(nextStateValue)[0];
            // try with parent
            var _b = this.states[subStateKey].next(event, history ? history.value : undefined), parentNextValue = _b[0], parentNextActions = _b[1];
            var nextActions = nextStateValue[subStateKey][1];
            return [
                parentNextValue,
                {
                    onEntry: nextActions.onEntry.concat(parentNextActions.onEntry),
                    actions: nextActions.actions.concat(parentNextActions.actions),
                    onExit: nextActions.onExit.concat(parentNextActions.onExit)
                }
            ];
        }
        if (this.parallel) {
            nextStateValue = __assign({}, utils_1.mapValues(this.initialState.value, function (subStateValue) { return [
                subStateValue,
                { onEntry: [], onExit: [], actions: [] }
            ]; }), nextStateValue);
        }
        var finalActions = {
            onEntry: [],
            actions: [],
            onExit: []
        };
        var finalStateValue = utils_1.mapValues(nextStateValue, function (_a, key) {
            var nextSubStateValue = _a[0], nextSubActions = _a[1];
            if (nextSubActions.onEntry) {
                (_b = finalActions.onEntry).push.apply(_b, nextSubActions.onEntry);
            }
            if (nextSubActions.actions) {
                (_c = finalActions.actions).push.apply(_c, nextSubActions.actions);
            }
            if (nextSubActions.onExit) {
                (_d = finalActions.onExit).push.apply(_d, nextSubActions.onExit);
            }
            if (!nextSubStateValue) {
                return stateValue[key];
            }
            return nextSubStateValue;
            var _b, _c, _d;
        });
        return [finalStateValue, finalActions];
        var _a;
    };
    StateNode.prototype.next = function (event, history, extendedState) {
        var eventType = utils_1.getEventType(event);
        var actionMap = { onEntry: [], onExit: [], actions: [] };
        if (this.onExit) {
            actionMap.onExit = this.onExit;
        }
        if (!this.on || !this.on[eventType]) {
            return [undefined, actionMap];
        }
        var transition = this.on[eventType];
        var nextStateString;
        if (typeof transition === 'string') {
            nextStateString = transition;
        }
        else {
            for (var _i = 0, _a = Object.keys(transition); _i < _a.length; _i++) {
                var candidate = _a[_i];
                // if (Array.isArray(transition[candidate])) {break;}
                var _b = transition[candidate], cond = _b.cond, transitionActions = _b.actions;
                var eventObject = typeof event === 'string' || typeof event === 'number'
                    ? { type: event }
                    : event;
                if (!cond || cond(extendedState, eventObject)) {
                    nextStateString = candidate;
                    if (transitionActions) {
                        actionMap.actions = actionMap.actions.concat(transitionActions);
                    }
                    break;
                }
            }
        }
        if (!nextStateString) {
            return [undefined, actionMap];
        }
        var nextStatePath = utils_1.toStatePath(nextStateString);
        var currentState = this.parent;
        var currentHistory = history;
        var currentPath = this.key;
        nextStatePath.forEach(function (subPath) {
            if (!currentState || !currentState.states) {
                throw new Error("Unable to read '" + subPath + "'");
            }
            if (subPath === HISTORY_KEY) {
                if (currentHistory) {
                    subPath =
                        typeof currentHistory === 'object'
                            ? Object.keys(currentHistory)[0]
                            : currentHistory;
                }
                else if (currentState.initial) {
                    subPath = currentState.initial;
                }
                else {
                    throw new Error("Cannot read '" + HISTORY_KEY + "' from state '" + currentState.id + "': missing 'initial'");
                }
            }
            currentState = currentState.states[subPath];
            if (currentState === undefined) {
                throw new Error("Event '" + event + "' on state '" + currentPath + "' leads to undefined state '" + nextStatePath + "'.");
            }
            if (currentState.onEntry) {
                actionMap.onEntry = actionMap.onEntry.concat(currentState.onEntry);
            }
            currentPath = subPath;
            if (currentHistory) {
                currentHistory = currentHistory[subPath];
            }
        });
        if (!currentState) {
            throw new Error('no state');
        }
        while (currentState.initial) {
            if (!currentState || !currentState.states) {
                throw new Error("Invalid initial state");
            }
            currentState = currentState.states[currentState.initial];
            if (currentState.onEntry) {
                actionMap.onEntry = actionMap.onEntry.concat(currentState.onEntry);
            }
        }
        return [currentState.getRelativeValue(this.parent), actionMap];
    };
    Object.defineProperty(StateNode.prototype, "initialStateValue", {
        get: function () {
            this.__cache.initialState =
                this.__cache.initialState ||
                    (this.parallel
                        ? utils_1.mapValues(this.states, function (state) { return state.initialStateValue; })
                        : this.initial);
            return this.__cache.initialState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "initialState", {
        get: function () {
            var initialStateValue = this.initialStateValue;
            if (!initialStateValue) {
                throw new Error("Cannot retrieve initial state from simple state '" + this.id + ".'");
            }
            var entryActions = this.getStateNodes(initialStateValue).reduce(function (actions, stateNode) {
                return stateNode.onEntry ? actions.concat(stateNode.onEntry) : actions;
            }, []);
            return new State_1.State(initialStateValue, undefined, entryActions);
        },
        enumerable: true,
        configurable: true
    });
    StateNode.prototype.getStates = function (stateValue) {
        var _this = this;
        if (typeof stateValue === 'string') {
            return [this.states[stateValue]];
        }
        var stateNodes = [];
        Object.keys(stateValue).forEach(function (key) {
            stateNodes.push.apply(stateNodes, _this.states[key].getStates(stateValue[key]));
        });
        return stateNodes;
    };
    StateNode.prototype.getState = function (relativeStateId) {
        var statePath = utils_1.toStatePath(relativeStateId);
        try {
            return statePath.reduce(function (subState, subPath) {
                if (!subState.states) {
                    throw new Error("Cannot retrieve subPath '" + subPath + "' from node with no states");
                }
                return subState.states[subPath];
            }, this);
        }
        catch (e) {
            throw new Error("State '" + relativeStateId + " does not exist on machine '" + this.id + "'");
        }
    };
    Object.defineProperty(StateNode.prototype, "events", {
        get: function () {
            if (this.__cache.events) {
                return this.__cache.events;
            }
            var states = this.states;
            var events = new Set(this.on ? Object.keys(this.on) : undefined);
            if (states) {
                Object.keys(states).forEach(function (stateId) {
                    var state = states[stateId];
                    if (state.states) {
                        for (var _i = 0, _a = state.events; _i < _a.length; _i++) {
                            var event_1 = _a[_i];
                            events.add("" + event_1);
                        }
                    }
                });
            }
            return (this.__cache.events = Array.from(events));
        },
        enumerable: true,
        configurable: true
    });
    StateNode.prototype.getRelativeValue = function (toNode) {
        var memoizedRelativeValue = toNode
            ? this.__cache.relativeValue.get(toNode)
            : undefined;
        if (memoizedRelativeValue) {
            return memoizedRelativeValue;
        }
        var initialStateValue = this.initialStateValue;
        var relativeValue = initialStateValue
            ? (_a = {},
                _a[this.key] = initialStateValue,
                _a) : this.key;
        var currentNode = this.parent;
        while (currentNode && currentNode !== toNode) {
            var currentInitialState = currentNode.initialStateValue;
            relativeValue = (_b = {},
                _b[currentNode.key] = typeof currentInitialState === 'object' &&
                    typeof relativeValue === 'object'
                    ? __assign({}, currentInitialState, relativeValue) : relativeValue,
                _b);
            currentNode = currentNode.parent;
        }
        this.__cache.relativeValue.set(toNode, relativeValue);
        return relativeValue;
        var _a, _b;
    };
    return StateNode;
}());
exports.StateNode = StateNode;
function Machine(config) {
    return new StateNode(config);
}
exports.Machine = Machine;



//////////////////
// WEBPACK FOOTER
// ./~/xstate/lib/index.js
// module id = 712
// module chunks = 168707334958949